// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@models';

export const environment: Environment = {
  name: 'stage',
  production: false,

  remoteApi: 'https://app-casino-event-gw-stage.azurewebsites.net/api',
  sentryDsn: 'https://8a9a2009a9ecbb08419ce6dfac523a41@o4508321490403328.ingest.us.sentry.io/4512226505785344',
  sentryEnvironment: 'stage',
};
